import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../../utils/utils';
export const Card = ({ children, className, variant = 'default', ...props }) => {
    return (_jsx("div", { ...props, className: cn('rounded-lg border border-solid border-neutral-200 size-full', {
            'bg-white shadow-sm': variant === 'default',
            'bg-neutral-50': variant === 'muted',
            'bg-white': variant === 'flat'
        }, className), children: children }));
};
